import React from 'react'
import httpClient from './myapi'
import { Container, Row, Col } from 'reactstrap'
import './styles/about.css'
import MyCarousel from './Carousel';

const _webserver = httpClient.WebServer + '/imgs';
export default class AboutUs extends React.Component {
    render() {
        return (
            <div>
                <h1 className="page-heading">About Us</h1>
                <Container>
                    <Row>
                        <Col>
                            <div>
                                <div className="abt-card">
                                    <img className="abt-img"
                                        src={_webserver + '/about1.jpg'} alt="Showroom" />
                                    <h5>About</h5>
                                    <p>
                                        पैठणी साठी लागणारे रेशीम हे आमच्याकडे रंगविले जात असून रेशीम रंगवून पैठणीसाठी त्याचा वापर केला जातो व रेशीम चे कच्चे धागे 100 डिग्री सेल्सियस पाण्यामध्ये रंग व कपड्याचा सोडा उकळत्या पाण्यामध्ये टाकून रेशमाचे वेगवेगळे रंग तयार केले जातात.
       आमच्याकडे सिंगल पदर, डबल पदर, टिशू पदर, मोर पोपट ब्रॉकेड , लोटस ब्रॉकेड, ऑल ओव्हर ब्रॉकेड बनविले जातात.
       आमच्या इथे साधारण ते महागड्या सर्व प्रकारच्या पैठण्या तयार केल्या जातात.  पैठणी बनविण्यासाठी लागणारा कालावधी सात-आठ दिवस ते सहा-आठ महिन्या पर्यंत लागतो. आमच्या पैठणी कारखान्यांमध्ये 50 पेक्षा जास्त हातमाग आहेत व  शंभराहून अधिक पैठणी कामगार पैठणी बनविण्यासाठी मेहनत घेतात.
       आमच्या शोरूम ला तुम्ही येऊन साडया बनवण्याचे सर्व काम बघू शकतात.
       आमच्या आऊटलेटमध्ये सर्व प्रकारच्या पैठणी, साड्या, लेडीज ड्रेस वेअर, टॉप, लेगिन्स, वन पीस, लेडीज, जीन्स, लेडीज टी-शर्ट व तसेच जेंट्स शर्ट, टी-शर्ट, जीन्स ,फॉर्मल पॅन्ट, ट्रॅक पॅन्ट, सुटिंग अँड शर्टींग सर्व प्रकारचे दालन आहेत.
                                 </p>
                                </div>
                            </div>
                            <div>
                                <div className="abt-card">
                                    <img className="abt-img2"
                                        src={_webserver + '/about2.jpg'} alt="outlet" />
                                    <h5>Showroom</h5>
                                    <p>
                                        आमच्या आऊटलेटमध्ये सर्व प्रकारच्या पैठणी, सिल्क साड्या, फॅन्सी साड्या, डिजायनर साड्या, नऊवार साड्या, ड्रेस मटेरियल,
       लेडीज ड्रेस वेअर, टॉप, लेगिन्स, वन पीस, लेडीज जीन्स, कुर्तीज, लेडीज टी-शर्ट
       मेन्स वेअर
        शर्ट्स, टी-शर्ट्स, जीन्स, ट्राऊजर, शेरवानी, ब्लेजर, कुर्ता-पायजमा, पार्टी वेअर, फॉर्मल पॅन्ट, ट्रॅक पॅन्ट, सुटिंग अँड शर्टींग व तसेच चिल्ड्रेन वेअर्स या सर्व प्रकारचे दालन आहेत.
    
                                 </p>
                                    {/* <p> */}
                                    <ul>
                                        <li>बस्त्याची खास व्यवस्था.</li>
                                        <li>प्रशस्त पार्किंग.</li>
                                        <li>शिर्डी मनमाड हायवे लगत.</li>
                                        <li>जलद कुरियर सेवा.</li>
                                        <li>ओपन वायफाय.</li>
                                        <li>पैठणी बनविण्याची प्रक्रिया समक्ष बघू शकता.</li>
                                    </ul>
                                    {/* </p> */}
                                </div>
                            </div>
                            <div className="abt-card">
                                <img className="abt-img"
                                    src={_webserver + '/about3.jpg'} alt="Workshop" />
                                <h5>Workshop</h5>
                                <p>
                                    पैठणी साठी लागणारे रेशीम हे आमच्याकडे रंगविले जात असून रेशीम रंगवून पैठणीसाठी त्याचा वापर केला जातो व रेशीम चे कच्चे धागे 100 डिग्री सेल्सियस पाण्यामध्ये रंग व कपड्याचा सोडा उकळत्या पाण्यामध्ये टाकून रेशमाचे वेगवेगळे रंग तयार केले जातात. आमच्याकडे सिंगल पदर, डबल पदर, टिशू पदर, मोर पोपट ब्रॉकेड , लोटस ब्रॉकेड, ऑल ओव्हर ब्रॉकेड बनविले जातात. आमच्या इथे साधारण ते महागड्या सर्व प्रकारच्या पैठण्या तयार केल्या जातात. पैठणी बनविण्यासाठी लागणारा कालावधी सात-आठ दिवस ते सहा-आठ महिन्या पर्यंत लागतो. आमच्या पैठणी कारखान्यांमध्ये 50 पेक्षा जास्त हातमाग आहेत व शंभराहून अधिक पैठणी कामगार पैठणी बनविण्यासाठी मेहनत घेतात. आमच्या शोरूम ला तुम्ही येऊन साडया बनवण्याचे सर्व काम बघू शकतात. आमच्या आऊटलेटमध्ये सर्व प्रकारच्या पैठणी, साड्या, लेडीज ड्रेस वेअर, टॉप, लेगिन्स, वन पीस, लेडीज, जीन्स, लेडीज टी-शर्ट व तसेच जेंट्स शर्ट, टी-शर्ट, जीन्स ,फॉर्मल पॅन्ट, ट्रॅक पॅन्ट, सुटिंग अँड शर्टींग सर्व प्रकारचे दालन आहेत.
                                 </p>
                            </div>
                        </Col>
                    </Row>
                    <Row>
                        <Col md={{ size: 8, offset: 2 }}>
                            <MyCarousel />
                        </Col>
                    </Row>
                </Container>

            </div>
        )
    }
}


// WEBPACK FOOTER //
// ./src/aboutus.jsx